import { getServiceURL } from "../utils/apiUtils";
import { apiInstance } from "../utils/axiosConfig";

export class TreatmentPlanTemplatesAPI {
  static get medicationTemplatesServiceName() {
    return "MEDICATION_TEMPLATES";
  }

  static get treatmentTemplatesServiceName() {
    return "TREATMENT_TEMPLATES";
  }

  static get draftTreatmentTemplateServiceName() {
    return "DRAFT_TREATMENT_TEMPLATE";
  }

  static get applyTreatmentTemplateServiceName() {
    return "APPLY_TREATMENT_PLAN";
  }

  static get applyMedicationTemplateServiceName() {
    return "APPLY_MEDICATION_TEMPLATE";
  }

  static async getMedicationTemplates() {
    const url = getServiceURL(
      TreatmentPlanTemplatesAPI.medicationTemplatesServiceName
    );
    const response = await apiInstance().get(url);
    return response?.data;
  }

  static async getTreatmentTemplates(data: any) {
    const { searchString, nailTypeMm, operationType, initialGapMm } = data;
    const url = getServiceURL(
      TreatmentPlanTemplatesAPI.treatmentTemplatesServiceName
    );
    const params = {
      ...searchString ? {searchString} : {},
      ...initialGapMm ? { initialGapMm } : {},
      ...operationType ? { operationType } : {},
      ...nailTypeMm ? { nailTypeMm } :  {}
    };
    const response = await apiInstance().get(url, { params });
    return response?.data;
  }

    static async deleteMedicationTemplate(id: string) {
    const url = `${getServiceURL(
      TreatmentPlanTemplatesAPI.medicationTemplatesServiceName
    )}/${id}`;
    const response = await apiInstance().delete(url);
    return response?.data;
  }

  static async applyMedicationTemplate(patientId: any, startDate: any, templateId: any) {
    const url = `${getServiceURL(TreatmentPlanTemplatesAPI.applyMedicationTemplateServiceName)}/${patientId}/templates?startDate=${startDate}&templateId=${templateId}`
    const response = await apiInstance().post(url);
    return response?.data;
  }

  static async getSingleMedicationTemplate(id: string) {
    const url = `${getServiceURL(
      TreatmentPlanTemplatesAPI.medicationTemplatesServiceName
    )}/${id}`;
    const response = await apiInstance().get(url);
    return response?.data;
  }

  static async getSingleTreatmentTemplate(id: string) {
    const url = `${getServiceURL(
      TreatmentPlanTemplatesAPI.treatmentTemplatesServiceName
    )}/${id}`;
    const response = await apiInstance().get(url);
    return response?.data;
  }

  static async updateMedicationTemplate(data: any, id: string) {
    const url = `${getServiceURL(
      TreatmentPlanTemplatesAPI.medicationTemplatesServiceName
    )}/${id}`;
    const response = await apiInstance().put(url, data);
    return response?.data;
  }

  static async createMedicationTemplate(data: any) {
    const url = getServiceURL(
      TreatmentPlanTemplatesAPI.medicationTemplatesServiceName
    );
    const response = await apiInstance().post(url, data);
    return response?.data;
  }

  static async createUpdateTreatmentTemplate(data: any) {
    const url = getServiceURL(
      TreatmentPlanTemplatesAPI.treatmentTemplatesServiceName
    );
    const response = await apiInstance().put(url, data);
    return response?.data;
  }

  static async deleteTreatmentTemplate(id: string) {
    const url = `${getServiceURL(
      TreatmentPlanTemplatesAPI.treatmentTemplatesServiceName
    )}/${id}`;
    await apiInstance().delete(url);
  }

  static async recalculateTreatmentTemplate(data: any) {
    const url = getServiceURL(
      TreatmentPlanTemplatesAPI.draftTreatmentTemplateServiceName
    );
    const response = await apiInstance().put(url, data);
    return response?.data;
  }

  static async applyTreatmentTemplate(data: any) {
    if (!data) return;
    const { startDate, templateId, patientId } = data;
    const url = `${getServiceURL(
      TreatmentPlanTemplatesAPI.applyTreatmentTemplateServiceName
    )}?startDate=${startDate}&templateId=${templateId}&patientId=${patientId}`;
    await apiInstance().post(url);
  }
}
